
      var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 120,
  viewBox: "0 0 120 120",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M94 89V43a6 6 0 0 0-6-6H12a6 6 0 0 0-6 6v46a6 6 0 0 0 6 6h76a6 6 0 0 0 6-6Z",
  stroke: "#000",
  strokeWidth: 4.4
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m9 40 41 40 41-40M32.5 64.5l-24 29M67 64.5l24 29",
  stroke: "#000",
  strokeWidth: 4.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M103.5 78h2.5a6 6 0 0 0 6-6V26a6 6 0 0 0-6-6H30a6 6 0 0 0-6 6v2.5",
  stroke: "#810EA9",
  strokeWidth: 4.4,
  strokeLinecap: "round"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"120\" height=\"120\" viewBox=\"0 0 120 120\" fill=\"none\">\r\n<path d=\"M94 89V43C94 39.6863 91.3137 37 88 37H77H23H12C8.68629 37 6 39.6863 6 43V89C6 92.3137 8.68629 95 12 95H88C91.3137 95 94 92.3137 94 89Z\" stroke=\"black\" stroke-width=\"4.4\"/>\r\n<path d=\"M9 40L50 80L91 40\" stroke=\"black\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M32.5 64.5L8.5 93.5\" stroke=\"black\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M67 64.5L91 93.5\" stroke=\"black\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M103.5 78H106C109.314 78 112 75.3137 112 72V26C112 22.6863 109.314 20 106 20H95H41H30C26.6863 20 24 22.6863 24 26V28.5\" stroke=\"#810EA9\" stroke-width=\"4.4\" stroke-linecap=\"round\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/success.1d9a9ba5e8370df6d45df92c1412dab7.svg"),
        {
          React: SvgSuccess,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      